import type { FunctionComponent, ReactElement } from 'react';

import styles from './TooltipRoot.module.css';

export const TooltipRoot: FunctionComponent = (): ReactElement => (
  <div className={styles.tooltipRoot} id="tooltipRoot" />
);
